import { createReducer, createFeature, on } from '@ngrx/store';

import { labelActions } from './protocol-labels.actions';
import { protocolLabelAdapter } from './labels.state';

const initialState = protocolLabelAdapter.getInitialState({
  loading: false,
  error: null,
});

const reducer = createReducer(
  initialState,
  on(labelActions.fetchLabelsByUUID, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(labelActions.fetchLabelsByUUIDSuccess, (state, { labels }) => {
    return protocolLabelAdapter.upsertMany(labels, { ...state, loading: false, error: null });
  }),
  on(labelActions.fetchLabelsByUUIDFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export const labelFeature = createFeature({
  name: 'protocolLabels',
  reducer,
});
